export default __webpack_public_path__ + "static/media/connect-nihongo.d941cc1f.svg";